import {
  LIVE_AGENT_CHAT_FAILURE,
  LIVE_AGENT_CHAT_REQUEST,
  LIVE_AGENT_CHAT_SUCCESS,
  SHIFT_CHAT_LIST,
} from '../actions/actionTypes';

const initialState = {
  chatList: [],
  isFetchingChatList: false,
  isErrorInChatList: null,
};

const liveAgentChat = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case LIVE_AGENT_CHAT_REQUEST:
        return {
          ...state,
          isFetchingChatList: true,
          isErrorInChatList: null,
        };
      case LIVE_AGENT_CHAT_SUCCESS:
        return {
          ...state,
          isFetchingChatList: false,
          chatList: action.payload,
          isErrorInChatList: null,
        };
      case LIVE_AGENT_CHAT_FAILURE:
        return {
          ...state,
          isFetchingChatList: false,
          isErrorInChatList: 'SomeThing went wrong.',
        };
      case SHIFT_CHAT_LIST:
        return {
          ...state,
          isFetchingChatList: false,
          chatList: action.payload,
        };
      default:
        return state;
    }
  }
};

export default liveAgentChat;
